import React from "react";
import {makeStyles} from "@mui/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    css: {
        display: 'inline-block',
    },
    myAnimation: {
        animation: `$shake 3000ms ${theme.transitions.easing.easeInOut} infinite`
    },
    "@keyframes shake": {
        "0%": {transform: "translate(1px, 1px) rotate(0deg)"},
        "10%": {transform: "translate(-1px, -2px) rotate(-1deg)"},
        "20%": {transform: "translate(-2px, 0px) rotate(1deg)"},
        "30%": {transform: "translate(2px, 2px) rotate(0deg)"},
        "40%": {transform: "translate(1px, -1px) rotate(1deg)"},
        "50%": {transform: "translate(-1px, 2px) rotate(-1deg)"},
        "60%": {transform: "translate(-2px, 1px) rotate(0deg)"},
        "70%": {transform: "translate(2px, 1px) rotate(-1deg)"},
        "80%": {transform: "translate(-1px, -1px) rotate(1deg)"},
        "100%": {transform: "translate(1px, 2px) rotate(0deg)"},
    }
}));

export const Shake = React.forwardRef((props, ref) => {
    const {disabled = false, children, ...other} = props;
    const classes = useStyles();

    return (
        <div ref={ref} {...other} className={clsx(classes.css, disabled ? undefined : classes.myAnimation)}>
            {children}
        </div>
    );
});